import clsx from "clsx";

import { Tooltip } from "@components/tooltip-container";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { PLATFORM_NORTHBEAM } from "@north-beam/nb-common";

import { type FormattedBreakdownTableRow } from "./table";

export const ControllerBreakdownFormatter = ({
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as FormattedBreakdownTableRow;
  const { designElementManager } = useDesignElementManager();

  const naming = row.label;
  let selectedBreakdown = row.breakdowns.find(
    (breakdown) => breakdown.value === row.label,
  );
  const isTopLevel = Object.hasOwn(row, "items");

  // If name and breakdown are the same, use the second breakdown
  // e.g. "Influencer" breakdown is the same as "Influencer" name
  if (
    !isTopLevel &&
    row.breakdowns.length > 1 &&
    row.breakdowns.every(({ value }) => value === naming)
  ) {
    selectedBreakdown = row.breakdowns[1];
  }

  const shouldDrawIcons =
    isTopLevel && selectedBreakdown?.key === PLATFORM_NORTHBEAM;

  const iconKey = selectedBreakdown?.value || "";
  const icon = designElementManager.getDesignElement(iconKey).getComponent({
    size: "20px",
  });

  return (
    <div className="flex flex-col justify-center h-full relative name-table-cell">
      <div className="flex items-center space-x-2 font-semibold font-sans truncate">
        {shouldDrawIcons && icon}
        <div className={clsx("truncate")}>
          <div
            className={clsx(
              "font-sans text-[0.5rem]",
              "text-gray+2 leading-3 uppercase truncate",
              "mb-1",
            )}
          >
            {selectedBreakdown?.key.toUpperCase() || "UNKNOWN"}
          </div>
          <Tooltip
            placement="top"
            content={naming}
            noInfoCircle
            className={clsx("text-primary", {
              "cursor-pointer hover:text-cosmic+1": true,
            })}
          >
            {naming}
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
